import VirtualCardsAllCardsReducer, {
  Actions as VirtualCardsAllCardsActions,
  initialState as initialVirtualCardsAllCardsState,
  VirtualCardsAllCardsState,
} from 'src/app/VirtualCardsAllCards/redux/virtualCardsAllCards.reducer'
import VirtualCardsRequestsReducer, {
  Actions as VirtualCardsRequestsActions,
  initialState as initialVirtualCardsRequestsState,
  VirtualCardsRequestsState,
} from 'src/app/VirtualCardsNeedsApproval/redux/virtualCardsNeedsApproval.reducers'

export type VirtualCardsState = {
  virtualCardsAllCards: VirtualCardsAllCardsState
  virtualCardsRequests: VirtualCardsRequestsState
}

export const initialState: VirtualCardsState = {
  virtualCardsAllCards: initialVirtualCardsAllCardsState,
  virtualCardsRequests: initialVirtualCardsRequestsState,
}

export type Actions = VirtualCardsAllCardsActions | VirtualCardsRequestsActions

const VirtualCardsReducer = (
  state = initialState,
  action: Actions,
): VirtualCardsState => ({
  virtualCardsAllCards: VirtualCardsAllCardsReducer(
    state.virtualCardsAllCards,
    action as VirtualCardsAllCardsActions,
  ),
  virtualCardsRequests: VirtualCardsRequestsReducer(
    state.virtualCardsRequests,
    action as VirtualCardsRequestsActions,
  ),
})

export default VirtualCardsReducer
